// @ts-nocheck
import React from 'react';
import axios from "axios";
import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import Typography from "@mui/material/Typography";
import Divider from '@mui/material/Divider';
import SinapThemev2 from "../../styles/SinapThemev2";
import useMediaQuery from '@mui/material/useMediaQuery';
import { ThemeProvider, StyledEngineProvider, styled } from '@mui/material/styles';
import Modal from '@mui/material/Modal';
import { useUsuarios } from "../State/UsuarioContext";
import CircularIndeterminate from "../../Componentes/CircularIndeterminate";
import Grid from "@mui/material/Grid";
import Switch from '@mui/material/Switch';
import { useHistory } from "react-router-dom";
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';
import { RUTA_API_USUARIOS, URL_KEYCLOAK } from "../../Contantes/Constantes";
import { useAuth } from "../../Auth/State/AuthContext";
import { useBody } from "../../Body/state/BodyContext";
import { ModalConfirmacion } from "../../Componentes/ModalConfirmacion";
import { BotonSecondary } from "../../Componentes/BotonSecondary";
import { Button } from "@mui/material";
import { useTheme } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
const Root = styled('div')(({ theme }) => ({
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '3%',
    width: 600,
    p: 4,
    backgroundColor: '#fff',
    [theme.breakpoints.down('lg')]: {
        width: '80%',
        height: '40%',
        padding: '6%'
    },
}));

const useStyles = makeStyles(theme => ({
    typografy: {
        marginTop: '2%',
        width: "100%",
        color: SinapThemev2.palette.primary.main,
    },
    acciones: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '10px',
        gap: '10px',
        height: '67px',
        order: '0',
        alignSelf: 'stretch',
        fontSize: '2px',

    },
    texto_acciones: {
        fontSize: '30px',
        fontWeight: 700,
    }
}))

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 380,
    bgcolor: 'background.paper',
    boxShadow: 24,
    borderRadius: '23px',
    p: 4,
};


export default function ModalAcciones({ setOpenModalForzar, setOpenModalHabilitar, setOpenModalVer, setOpenModalAlias, prev, open, onClose, ...props }) {
    const classes = useStyles();
    const { setMessage, setInfo } = useBody();
    let history = useHistory();
    const matches = useMediaQuery('(max-width:600px)');
    const { user, hasRole, handleImpersonate } = useAuth();
    const [loading, setLoading] = React.useState(false);
    const axiosInstance = setupInterceptorsTo(axios.create());
    const { fetchUsuario } = useAuth();
    const [openConfirmarLDAP, setOpenConfirmarLDAP] = React.useState(false);
    const [openConfirmarGoogle, setOpenConfirmarGoogle] = React.useState(false);
    const [openConfirmarAD, setOpenConfirmarAD] = React.useState(false);
    const [openConfirmarVPN, setOpenConfirmarVPN] = React.useState(false);
    const [openConfirmarWIFI, setOpenConfirmarWIFI] = React.useState(false);
    const [tooltipOpen, setTooltipOpen] = React.useState(false);
    const { checkSolicitudUserInAD, hasSolicitudAD, deleteUserInAD, createUserInAD, fetchEstadoUsuarioEnAD, fetchEstadoUsuarioEnVPN, estadoVPN, addUserVPN, deleteUserVPN, setEstadoAD, estadoAD, fetchEstadoUsuarioEnGoogle, estadoGoogle, estadoLDAP, fetchEstadoUsuarioEnLDAP, deshabilitarCuentaGoogle, deshabilitarCuentaLDAP, estado404Google, estadoWIFI, fetchEstadoUsuarioEnWIFI, addUserWIFI, deleteUserWIFI } = useUsuarios();
    const [openNested, setOpenNested] = React.useState(true);

    const handleClick = () => {
        setOpenNested(!openNested);
    };

    React.useEffect(() => {
        if (prev !== undefined)
            if (prev.uid !== '') {
                fetchEstadoUsuarioEnGoogle(prev.frbaEmail)
                fetchEstadoUsuarioEnLDAP(prev.uid)
                checkSolicitudUserInAD(prev.uid)
                fetchEstadoUsuarioEnAD(prev.uid)
                fetchEstadoUsuarioEnVPN(prev.uid)
                fetchEstadoUsuarioEnWIFI(prev.uid)
            }
    }, [prev])

    const handleChangeGoogle = async () => {
        deshabilitarCuentaGoogle(prev.frbaEmail, !estadoGoogle, prev.personalEmail)
    }

    const handleChangeLDAP = async () => {
        deshabilitarCuentaLDAP(prev.uid, !estadoLDAP, prev.personalEmail)
    }

    const handleChangeAD = async () => {
        if (!estadoAD) {
            createUserInAD(prev.uid)
        } else {
            deleteUserInAD(prev.uid)
        }
        setOpenConfirmarAD(false)
    }

    const handleChangeVPN = async () => {
        if (!estadoVPN) {
            addUserVPN(prev.uid)
        } else {
            deleteUserVPN(prev.uid)
        }
    }
    const handleChangeWIFI = async () => {
        if (!estadoWIFI) {
            addUserWIFI(prev.uid)
        } else {
            deleteUserWIFI(prev.uid)
        }
    }

    React.useEffect(() => {
        if (prev !== undefined)
            if (prev.uid !== '') {
            }
    }, [prev])


    const handleMouseEnter = () => {
        if (hasSolicitudAD) {
            setTooltipOpen(true);
        }
    };

    const handleMouseLeave = () => {
        setTooltipOpen(false);
    };

    const impersonarUsuario = async () => {
        await handleImpersonate(prev.uid).then(response => {
            if (response === 1) {
                onClose()
                history.push('/')
            }
            else if (response === 2)
                setInfo("Usted no se puede impersonar a si mismo")
            else
                setMessage("Hubo un error al querer impersonar el usuario")
        });

    }


    function ContenedorConfirmacion({
        open,
        accion,
        mensajePrimario,
        mensajeSecundario,
        colorAceptar,
        mensajeAceptar,
        handleClose
    }) {
        const theme = useTheme();
        const matches = useMediaQuery(theme.breakpoints.down('md'));

        const aceptar = () => {
            handleClose();
            accion();
        };

        return (
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <div
                    style={{
                        backgroundColor: '#fff',
                        borderRadius: '12px',
                        boxShadow: theme.shadows[5],
                        padding: matches ? '16px' : '32px',
                        maxWidth: '500px',
                        margin: 'auto',
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        textAlign: 'center',
                    }}
                >
                    <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        gutterBottom
                        style={{ fontWeight: 'bold' }}
                    >
                        {mensajePrimario}
                    </Typography>
                    <Typography
                        id="modal-modal-description"
                        variant="body1"
                        color="textSecondary"
                        gutterBottom
                    >
                        {mensajeSecundario}
                    </Typography>
                    <Grid container spacing={2} justifyContent="flex-end" style={{ marginTop: '16px' }}>
                        <Grid item>
                            <Button
                                variant="outlined"
                                onClick={handleClose}
                                style={{
                                    textTransform: 'none',
                                    borderColor: theme.palette.grey[400],
                                }}
                            >
                                No, cancelar
                            </Button>
                        </Grid>
                        <Grid item>
                            <Button
                                variant="contained"
                                onClick={aceptar}
                                style={{
                                    backgroundColor: colorAceptar,
                                    color: '#fff',
                                    textTransform: 'none',
                                }}
                            >
                                {mensajeAceptar}
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Modal>
        );
    }


    return (
        <Box>
            {
                loading ? <Grid
                    container
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                > <CircularIndeterminate /> </Grid>
                    :
                    <>
                        <ContenedorConfirmacion
                            open={openConfirmarLDAP}
                            handleClose={() => setOpenConfirmarLDAP(false)}
                            accion={handleChangeLDAP}
                            mensajeAceptar={"Si, confirmar"}
                            mensajePrimario={"¿Esta seguro que quiere cambiar el estado del usuario " + prev.uid + " en LDAP ?"}
                            mensajeSecundario={"Una vez confirmado, tendrá que esperar a que se termine el proceso de suspension para volver a habilitar"}
                            colorAceptar={SinapThemev2.palette.success.main}
                        />
                        <ContenedorConfirmacion
                            open={openConfirmarGoogle}
                            handleClose={() => setOpenConfirmarGoogle(false)}
                            accion={handleChangeGoogle}
                            mensajeAceptar={"Si, confirmar"}
                            mensajePrimario={"¿Esta seguro que quiere cambiar el estado del usuario " + prev.uid + " en Google ?"}
                            mensajeSecundario={"Una vez confirmado, tendrá que esperar a que se termine el proceso de suspension para volver a habilitar"}
                            colorAceptar={SinapThemev2.palette.success.main}
                        />
                        <ContenedorConfirmacion
                            open={openConfirmarAD}
                            handleClose={() => setOpenConfirmarAD(false)}
                            accion={handleChangeAD}
                            mensajeAceptar={"Si, confirmar"}
                            mensajePrimario={"¿Esta seguro que quiere cambiar el estado del usuario " + prev.uid + " en el Active Directory ?"}
                            mensajeSecundario={"Una vez confirmado, tendrá que esperar a que se termine el proceso para volver a habilitar"}
                            colorAceptar={SinapThemev2.palette.success.main}
                        />
                        <ContenedorConfirmacion
                            open={openConfirmarVPN}
                            handleClose={() => setOpenConfirmarVPN(false)}
                            accion={handleChangeVPN}
                            mensajeAceptar={"Si, confirmar"}
                            mensajePrimario={"¿Esta seguro que quiere cambiar el estado del usuario " + prev.uid + " en la VPN ?"}
                            mensajeSecundario={"Una vez confirmado, tendrá que esperar a que se termine el proceso para volver a habilitar"}
                            colorAceptar={SinapThemev2.palette.success.main}
                        />
                        <ContenedorConfirmacion
                            open={openConfirmarWIFI}
                            handleClose={() => setOpenConfirmarWIFI(false)}
                            accion={handleChangeWIFI}
                            mensajeAceptar={"Si, confirmar"}
                            mensajePrimario={"¿Esta seguro que quiere cambiar el estado del usuario " + prev.uid + " en el grupo WIFI ?"}
                            mensajeSecundario={"Una vez confirmado, tendrá que esperar a que se termine el proceso para volver a habilitar"}
                            colorAceptar={SinapThemev2.palette.success.main}
                        />
                        <Modal
                            keepMounted
                            open={open}
                            onClose={onClose}
                            aria-labelledby="keep-mounted-modal-title"
                            aria-describedby="keep-mounted-modal-description"
                        >
                            <Box sx={style}>
                                <StyledEngineProvider injectFirst>
                                    <ThemeProvider theme={SinapThemev2}>
                                        <Grid
                                            justifyContent="center"
                                            alignItems="center"
                                            container
                                            spacing={2}>
                                            <Grid item xs={12}>
                                                <div className={classes.acciones}><Typography variant="h5" className={classes.texto_acciones}>Acciones</Typography></div>
                                            </Grid>
                                            <Grid item xs={12}>
                                            <Divider />

                                                <List
                                                    sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}
                                                    component="nav"
                                                    aria-labelledby="nested-list-subheader"
                                                >
                                                    <ListItemButton onClick={() => setOpenModalVer(true)}>
                                                        <ListItemText primary="Ver perfil" />
                                                        <VisibilityIcon />
                                                    </ListItemButton>
                                                    {hasRole(["ROLE_SUSPENDER_USUARIOS"]) && (
                                                        <>
                                                            <ListItemButton onClick={handleClick}>
                                                                <ListItemText primary="Modificar Estado de usuario" />
                                                                {openNested ? <ExpandLess /> : <ExpandMore />}
                                                            </ListItemButton>
                                                            <Collapse in={openNested} timeout="auto" unmountOnExit>
                                                                <List component="div" disablePadding>
                                                                    <ListItemButton sx={{ pl: 4 }}>
                                                                        <ListItemText primary="Habilitado en LDAP" />
                                                                        <Switch checked={estadoLDAP} onChange={() => setOpenConfirmarLDAP(true)} defaultChecked size="small" />
                                                                    </ListItemButton>
                                                                    <ListItemButton disabled={estado404Google} sx={{ pl: 4 }}>
                                                                        <ListItemText disabled={estado404Google} primary="Habilitado en Google" />
                                                                        <Switch disabled={estado404Google} checked={estadoGoogle} onChange={() => setOpenConfirmarGoogle(true)} defaultChecked size="small" />
                                                                    </ListItemButton>
                                                                </List>
                                                            </Collapse>
                                                        </>
                                                    )}
                                                    {hasRole(["ROLE_MODIFICAR_PASSWORD_LDAP"]) && (
                                                        <ListItemButton onClick={() => setOpenModalForzar(true)}>
                                                            <ListItemText primary="Forzar cambio de contraseña" />
                                                            <LockIcon />
                                                        </ListItemButton>
                                                    )}
                                                    {hasRole(["ROLE_IMPERSONAR"]) && (
                                                        <ListItemButton onClick={impersonarUsuario} >
                                                            <ListItemText primary="Cambiar con este usuario" />
                                                            <PeopleAltIcon />
                                                        </ListItemButton>
                                                    )}
                                                    {hasRole(["ROLE_MODIFICAR_ALIAS"]) && (
                                                        <ListItemButton onClick={() => setOpenModalAlias(true)}>
                                                            <ListItemText primary="Administrar Mail FRBA" />
                                                            <AlternateEmailIcon />
                                                        </ListItemButton>
                                                    )}
                                                    {(hasRole(["ROLE_ELIMINAR_USUARIO_AD"]) || hasRole(["ROLE_CREAR_USUARIO_AD"])) && (
                                                        <ListItemButton>
                                                            <ListItemText primary="Grupo LDAP DOMAIN USERS" />
                                                            <Tooltip
                                                                title="Esperando que el usuario complete el formulario"
                                                                open={tooltipOpen}
                                                                disableInteractive
                                                                arrow
                                                            >
                                                                <span
                                                                    onMouseEnter={handleMouseEnter}
                                                                    onMouseLeave={handleMouseLeave}
                                                                >
                                                                    <Switch
                                                                        checked={estadoAD}
                                                                        onChange={() => setOpenConfirmarAD(true)}
                                                                        defaultChecked
                                                                        size="small"
                                                                        disabled={hasSolicitudAD}
                                                                    />
                                                                </span>
                                                            </Tooltip>
                                                        </ListItemButton>
                                                    )}
                                                    {hasRole(["ROLE_MODIFICAR_GRUPO_VPN"]) && (
                                                        <ListItemButton>
                                                            <ListItemText primary="Grupo VPN" />
                                                            <Switch checked={estadoVPN} onChange={() => setOpenConfirmarVPN(true)} defaultChecked size="small" />
                                                        </ListItemButton>
                                                    )}
                                                    {hasRole(["ROLE_SOPORTE"]) && (
                                                        <ListItemButton>
                                                            <ListItemText primary="Grupo WIFI" />
                                                            <Switch checked={estadoWIFI} onChange={() => setOpenConfirmarWIFI(true)} defaultChecked size="small" />
                                                        </ListItemButton>
                                                    )}
                                                </List>
                                            </Grid>
                                        </Grid>

                                    </ThemeProvider>
                                </StyledEngineProvider>
                            </Box>
                        </Modal>
                    </>
            }
        </Box>
    );
}